import get from 'lodash/get';

const styles = theme => ({
  rootDark: {
    width: '80%',
    backgroundColor: get(theme, 'color.darkGreyBackground'),
    color: get(theme, 'color.white'),
    padding: 5,
    borderRadius: 4,
    boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
    '& > div': {
      width: '100%',
    },
  },
  rootLight: {
    width: '80%',
    backgroundColor: get(theme, 'color.white'),
    color: '#000000',
    padding: 5,
    borderRadius: 4,
    boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
    '& > div': {
      width: '100%',
    },
  },
  messageContainer: {
    width: '90%',
    float: 'left',
    paddingLeft: 4,
    fontSize: get(theme, 'fontSize.smallText'),
    fontFamily: get(theme, 'typography.bodyText'),
    '& a': {
      color: get(theme, 'color.link'),
    },
  },
  iconInfo: {
    fontSize: 30,
  },
  infoContainer: {
    width: '5%',
    float: 'left',
  },
  closeContainer: {
    paddingRight: 5,
    width: '3%',
    float: 'left',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/CookiePolicyBanner/styles.js